export default __webpack_public_path__ + "static/media/Remington_Wood1.a97f19b2.jpg";